import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateProjectComment } from '@/api/v4/project-comments.api';
import { notify } from '@/ui/snackbar/notify';
import { QueryKey } from '@/config/query-client';
import { projectIdState } from '../../project.state';
import { useAtomValue } from 'jotai';

export const useUpdateProjectComment = () => {
  const { t } = useTranslation('default');
  const projectId = useAtomValue(projectIdState);

  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: updateProjectComment,
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [QueryKey.Project, projectId],
        }),
        queryClient.invalidateQueries({
          queryKey: [QueryKey.ProjectComments, projectId],
        }),
        queryClient.invalidateQueries({ queryKey: [QueryKey.LastActivities] }),
        queryClient.invalidateQueries({
          queryKey: [QueryKey.LastActivitiesCount],
        }),
      ]);
    },
    onError: () => {
      notify({
        message: t`unknownError`,
      });
    },
  });

  return {
    updateComment: mutation.mutateAsync,
    isError: mutation.isError,
    isUpdateInProgress: mutation.isPending,
  };
};
